import * as Yup from 'yup'

const merchantOutboundReturnEditSchema = Yup.object().shape({
  courier: Yup.string()
    .required('Required'),
  shipment_type: Yup.string()
    .required('Required'),
  tracking_no: Yup.string()
    .required('Required'),
  street_address: Yup.string()
    .required('Required'),
  kecamatan: Yup.string()
    .required('Required'),
  kelurahan: Yup.string()
    .required('Required'),
  kota: Yup.string()
    .required('Required'),
  provinsi: Yup.string()
    .required('Required'),
  kodepos: Yup.string()
    .required('Required')
    .matches(/^\d{5}(?:[-\s]\d{4})?$/, 'Invalid postal code')
    .min(5, 'At least 5 digits')
})

export default merchantOutboundReturnEditSchema
